<template>
	<div class="v5-switch">
		<div class="v5-switch-out" :style="switchStyle" :class="suitClass" @click="changeState">
			<span class="v5-switch-in" :class="{'v5-switch-open': currentValue === onValue}"></span>
			<span :class="{'falseText':currentValue === offValue,'trueText':currentValue ===onValue}">
				<slot name="open" v-if="currentValue === onValue"></slot>
				<slot name="close" v-if="currentValue === offValue"></slot>
			</span>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'v5-Switch',
		computed: {
			offStyle() {
				return {
					backgroundColor: this.offColor
				};
			},
			onStyle() {
				return {
					backgroundColor: this.onColor
				};
			},
			switchStyle() {
				if (this.currentValue === this.onValue) {
					return this.onStyle;
				} else if (this.currentValue === this.offValue) {
					return this.offStyle;
				}
			},
			suitClass() {
				return `v5-switch-${this.size}`;
			}
		},
		props: {
			value: {
				type: [String, Number, Boolean],
				default: true
			},
			onValue: {
				type: [String, Number, Boolean],
				default: true
			},
			offValue: {
				type: [String, Number, Boolean],
				default: false
			},
			size: {
				type: String,
				default: 'normal'
			},
			disabled: {
				type: Boolean,
				default: false
			},
			onColor: {
				type: String,
				default: '#ff552e'
			},
			offColor: {
				type: String,
				default: '#bdc0bc'
			}
		},
		data() {
			return {
				currentValue: this.value
			};
		},
		watch: {
			value(val) {
				this.currentValue = val;
			}
		},
		methods: {
			changeState() {
				if (!this.disabled) {
					this.currentValue = this.currentValue === this.onValue ? this.offValue : this.onValue;
					this.$emit('on-change', this.currentValue);
				}
			}
		}
	};

</script>
<style lang="scss">
	@import './style.scss';

</style>
